<template>
  <base-page-layout :title="pageTitle" :filters="[]">
    <template #page-status>
      <chip-on-approval v-if="onApprovalVersion" />
    </template>
    <div v-if="!isNewRaffle && !onApprovalVersion && raffle.status !== 'DRAFT' && raffle.status !== 'SCHEDULED'" class="tabs-button-header">
      <mf-tabs-menu v-model="tab" :tabs="tabs" class="mb-5" />
    </div>
    <edit-raffle-info v-if="tab === 0 || isNewRaffle" :is-loading="isLoading" :is-new-raffle="isNewRaffle" @changePage="handlePageChange" />
    <edit-raffle-winners v-else :is-loading="isLoading" @refreshPage="refreshPage" />
  </base-page-layout>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

import BasePageLayout from '@/components/BasePageLayout.vue'
import EditRaffleInfo from '../components/EditRaffleInfo.vue'
import ChipOnApproval from '../components/ChipOnApproval.vue'
import EditRaffleWinners from '../components/EditRaffleWinners.vue'

export default {
  name: 'EditRaffle',
  components: {
    BasePageLayout,
    EditRaffleInfo,
    ChipOnApproval,
    EditRaffleWinners,
  },
  data: () => ({
    isConfirmRafflePage: false,
    tab: 0,
    isLoading: true,
    onApprovalVersion: false,
  }),
  computed: {
    ...mapState({
      raffle: (state) => state.sorteio.raffle,
    }),
    pageTitle() {
      if (this.isConfirmRafflePage) return 'Confirme o sorteio'
      if (this.isNewRaffle) return 'Novo sorteio'
      return 'Editar sorteio'
    },
    isNewRaffle() {
      return !this.$route.params.id
    },
    tabs() {
      return [
        {
          name: 'Sorteio',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Gestão do ganhador',
          itemsLength: 0,
          haveLength: false,
        },
      ]
    },
  },
  watch: {
    '$route.query': {
      handler: async function () {
        this.isLoading = true
        await this.initRaffle()
      },
      deep: true,
    },
  },
  async mounted() {
    await this.initRaffle()
    if (this.$route.query?.fromRaffleResult) {
      this.tab = 1
    }
  },
  methods: {
    ...mapActions(['getRaffle', 'getRaffleOnApproval', 'getRaffleLuckyNumbersMetrics']),
    ...mapMutations(['resetRaffle', 'setRaffleType']),
    async initRaffle() {
      await this.resetRaffle()
      if (this.isNewRaffle) {
        let raffleType
        switch (this.$route.query['raffle-type']) {
          case 'valor-total-cupom':
            raffleType = 'BY_COUPON_TOTAL_VALUE'
            break
          case 'quantidade-items':
            raffleType = 'BY_SELECTED_ITEMS_QUANTITY'
            break
          case 'valor-items-selecionados':
            raffleType = 'BY_SELECTED_ITEMS_VALUE'
            break
          case 'valor-compra-item-selecionado':
            raffleType = 'BY_COUPON_TOTAL_VALUE_PARTICIPANT_PRODUCT'
            break
          case 'valor-compra-produtos-aceleradores':
            raffleType = 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT'
            break
          case 'valor-compra-grupos-de-produtos-aceleradores':
            raffleType = 'BY_COUPON_TOTAL_VALUE_ACCELERATOR_PRODUCT_GROUPS_WITH_CUMULATIVE'
            break
          default:
            break
        }
        this.setRaffleType(raffleType)
        this.isLoading = false
      } else {
        await this.getData()
      }
    },
    handlePageChange(isConfirmRafflePage) {
      this.isConfirmRafflePage = isConfirmRafflePage
    },
    refreshPage() {
      this.isLoading = true
      this.getData()
    },
    async getData() {
      try {
        this.onApprovalVersion = this.$route.query.on_approval_version === 'true'
        const queryContext = {
          apollo: this.$apollo,
          raffleId: this.$route.params.id,
        }
        if (this.$route.params.id) {
          if (this.onApprovalVersion) {
            await this.getRaffleOnApproval(queryContext)
          } else {
            await this.getRaffle(queryContext)
          }

          this.isLoading = false
          await this.getRaffleLuckyNumbersMetrics(queryContext)
        }
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      }
    },
  },
}
</script>
